import { Component, Input } from '@angular/core';

@Component({
  selector: 'rl-loader',
  templateUrl: './loader.component.html',
})
export class LoaderComponent {
  @Input() message: string;
}
